export var Songbird = {
  chainId: 19,
  chainName: 'Songbird',
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: '0x60351436cf80A31EA6C3B261C784d3C127dBD6f1',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://songbird-explorer.flare.network/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://songbird-explorer.flare.network/tx/".concat(transactionHash);
  }
};